export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  CANCELED = 'CANCELED',
  PRELIMINARY = 'PRELIMINARY',
}
